import { DownloadOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import * as React from 'react';

import { useUploadFormStore } from 'stores/local/forms/UploadFormStore';

import { InstructionItemContent } from '../InstructionItemContent';

type InstructionDownloadFileProps = {
  text: React.ReactNode;
  number: number;
  buttonText: React.ReactNode;
};

/**
 * Карточка с инструкцией по скачке файла
 * @param text
 * @param number
 * @param buttonText
 * @constructor
 */
const InstructionDownloadFile: React.FC<InstructionDownloadFileProps> = ({
  text,
  number,
  buttonText,
}) => {
  const { downloadButtonParams } = useUploadFormStore();

  return (
    <Space size={12} direction="vertical" style={{ width: '100%' }}>
      <InstructionItemContent number={number}>{text}</InstructionItemContent>
      <Button
        icon={<DownloadOutlined />}
        block
        type="default"
        {...downloadButtonParams}
      >
        {buttonText}
      </Button>
    </Space>
  );
};

export default InstructionDownloadFile;
